<ng-container *ngIf="isOtpService==false"> 
    <headerbar>OTP {{formPage}}</headerbar>    
    <div class="content-wrapper-no-nav" >        
        <div class="signin-area">
            <div class="container">
                <div class="signin-area-inner text-center mb-4">
                    <img src="assets/img/login_background.png" alt="img">
                    <h3 class="text-white">Verications</h3>
                    <p class="text-color">{{ 'otpdescription' | translate}} <br> {{phoneNumber}}</p>
                    <p class="text-color">{{ 'otptitle' | translate}}</p>
                </div>
                <form class="verify-form-inner text-center">                    
                    <code-input  [isCodeHidden]="false" [codeLength]="6" (codeChanged)="onCodeCompleted($event)"
                      (keyup.enter)="validateOtp()"  class="text-dark" ></code-input>                      
                    <p id="passErr" class="text-warning text-center w-100" ></p>        
                    <div class="counterTimer" *ngIf="counterTimer > 0">{{counterTimer}}</div>                  
                    <div class="text-right  mt-2" (click)="getOtp()" *ngIf="counterTimer == 0">
                        <p class="text-color">I didn’t receive code. Resend Code</p>
                    </div>
                    <a class="btn-large btn-blue w-100 mt-2" (click)="checkOtp()">{{ 'next' | translate}}</a>
                </form>
                <div class="err__msg my-4">
                    <div (click)="goToServicePhone()" class="text__link text-color"> {{'code_err_msg' | translate}} {{'help' | translate}}</div>
                </div>        
            </div>
        </div>   
    </div>
</ng-container>
<ng-container *ngIf="isOtpService==true">
    <app-otp-service-phone (backemit)="showOptPage($event)"></app-otp-service-phone>
</ng-container> 
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  